import { render } from "./BookingHistoryBanner.vue?vue&type=template&id=5a863b70"
import script from "./BookingHistoryBanner.vue?vue&type=script&lang=js"
export * from "./BookingHistoryBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__